import { Device } from './device';


export class VehicleDeviceLocation {
    locationId: number;
    locationName: string;
    devices: Device[];
}
